import React, { useEffect, useState } from "react";
import { colors, fonts } from "../Styles";

// #region | Clock element
export const Clock = () => {
  const [dateTime, setDateTime] = useState(new Date());
  const [intervalId, setIntervalId] = useState<NodeJS.Timer | null>(null);

 
  function stopClock() {
    if (intervalId) clearInterval(intervalId);
  }

  function startClock() {
    stopClock();
    const newIntervalId = setInterval(() => {
      setDateTime(new Date());
    }, 10000); // Update every minute
    setIntervalId(newIntervalId);
  }

  useEffect(() => {
    // Page is loaded
    startClock();
    // Cleanup on component unmount
    return () => stopClock();
  }, []);


  return (
    <div style={{
      color: colors.greyLightTertiary,
      ...fonts.header, 
      ...fonts.textShadow,
      ...fonts.fontSize4,
    }}>
    <p>
        {dateTime.toLocaleString('default', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false // 24-hour format
        }).replace(/,/g, '')}
      </p>
    </div>
  );
};
    // ---------------------------------------------------
    //#endregion